// Copyright (c) 2018 Deere & Company

import './index.scss';
import ExcelLayout, {getDefaultState as getExcelLayoutDefaultState} from '@deere/cps-it.warranty-model-factory/lib/excel-layout';
import React, {PropTypes} from 'react';
import ActionsPopover from '../../actions-popover';
import OptionsDropDown from '../../options-drop-down';
import {getOptions} from '../services/get-options';

function handleExcelLayoutChange(layoutName) {

    const selectedLayout = layoutName ?
        this.excelLayouts.find(layout => layout.name === layoutName) :
        getExcelLayoutDefaultState();

    this.onLayoutChange(selectedLayout);

}

const ExcelLayoutHeaderBar = props => {

    const options = getOptions(props.onCreateLayout, props.onEditLayout, props.selectedLayout.name);

    return (
        <div className='excel-layout-header-bar'>
            <OptionsDropDown
                alwaysCallOnChange={true}
                className='excel-layouts-dropdown'
                isPlaceholderTranslated={false}
                isRequired={false}
                onChange={props::handleExcelLayoutChange}
                optionDisplayAttributes={['name']}
                optionKey='name'
                options={props.excelLayouts}
                placeholder='STANDARD_VIEW'
                selectedValue={props.selectedLayout.name}
                showPlaceholder={true}
            />
            <div className='actions-button'>
                <ActionsPopover options={options}/>
            </div>
        </div>
    );

};

ExcelLayoutHeaderBar.displayName = 'ExcelLayoutHeaderBar';
ExcelLayoutHeaderBar.propTypes = {
    excelLayouts: PropTypes.arrayOf(PropTypes.instanceOf(ExcelLayout)).isRequired,
    onCreateLayout: PropTypes.func.isRequired,
    onEditLayout: PropTypes.func.isRequired,
    onLayoutChange: PropTypes.func.isRequired,
    selectedLayout: PropTypes.instanceOf(ExcelLayout).isRequired
};

export default ExcelLayoutHeaderBar;



// WEBPACK FOOTER //
// ./src/shared/components/excel-layout/excel-layout-header-bar/index.js